import { Button, Typography } from '@mui/material';
import { t } from '@ankr.com/common';

import { PersonalAccountButtonIcon } from './components/PersonalAccountButtonIcon';
import { usePersonalAccountButton } from './hooks/usePersonalAccountButton';
import { usePersonalAccountButtonStyles } from './usePersonalAccountButtonStyles';

export interface PersonalAccountButtonProps {
  onClick: () => void;
}

export const PersonalAccountButton = ({
  onClick,
}: PersonalAccountButtonProps) => {
  const { accountName } = usePersonalAccountButton();

  const { classes } = usePersonalAccountButtonStyles();

  return (
    <Button
      className={classes.root}
      classes={{ startIcon: classes.startIcon }}
      onClick={onClick}
      startIcon={<PersonalAccountButtonIcon />}
      variant="text"
    >
      <div className={classes.accountInfo}>
        <Typography className={classes.accountName} variant="body2">
          {accountName}
        </Typography>
        <Typography className={classes.accountSettings} variant="body3">
          {t('account-menu.personal-account-settings')}
        </Typography>
      </div>
    </Button>
  );
};
